export const IdentificationTypes = Object.freeze({
    DRIVER_LICENSE: 'driver',
    IDENTITY_CARD: 'idcard',
    PASSPORT: 'passport',
    RESIDENCE_PERMIT: 'residence',
});